module.exports = __webpack_public_path__ + "static/media/andrew-moroz-resume-p1.d6d539ba.jpg";